<div class="top-financial super-bookingtabs">
  <div class="create-booking">
    <ul>
      <h5 *ngIf="!isManageInvoiceHeader">Financials Report  till {{formattedDate}}</h5>
      <h5 *ngIf="isManageInvoiceHeader">Search data by filter</h5>
      <li>
        <div *ngIf="isParkingManagerOrOwner && !isFinancialRoute && hasShowPermission" (click)="navigateToCreateCustom()" class="booking-inner">
          <img src="../../../../assets/images/create-booking.svg" alt="Booking create"/>
          <span>Create Custom Invoice</span>
        </div>
      </li>
      </ul>  
  </div>
  <div class="table-card custom-tabs">
    <div class="table-top flex justify-content-between align-items-center">
      <div class="custom-tabs super-bookingtabs">
        <p-button 
          *ngIf="bookingInvoicesTab" 
          [queryParams]="{'tab': 0}" 
          class="tabs-button" 
          (onClick)="setActiveTab(0)" 
          [class.tabs-active]="isTabActive(0)" 
          [label]="bookingInvoicesTab.label">
        </p-button>
        <p-button 
          [queryParams]="{'tab': 1}" 
          class="tabs-button" 
          (onClick)="setActiveTab(1)" 
          [class.tabs-active]="isTabActive(1)" 
          [label]="customInvoicesTab.label">
        </p-button>
      </div>
    </div>
    <div>
      <ng-container *ngIf="activeIndex === 0 && bookingInvoicesTab" [ngComponentOutlet]="bookingInvoicesTab.component"></ng-container>
      <ng-container *ngIf="activeIndex === 1" [ngComponentOutlet]="customInvoicesTab.component"></ng-container>
    </div>
  </div>
</div>